import React, { useEffect, useState } from "react";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./Winner.module.css";
import gameConfig from "../../gameConfig";

import MedalImage from "../../images/medal.png";

function Winner({ score, sounds }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("common");

  const [timeoutId, setTimeoutId] = useState(null);

  let winnerTexts = [];
  if (score.player1.score > score.player2.score) {
    winnerTexts = ["1"];
  } else if (score.player1.score < score.player2.score) {
    winnerTexts = ["2"];
  } else {
    winnerTexts = ["1", "2"];
  }

  const returnToFirstScreenByTimeout = () => {
    const id = setTimeout(() => {
      navigate("/");
    }, gameConfig.showWinnerScreenTime);
    setTimeoutId(id);
  };

  useEffect(() => {
    sounds.winnerSound();
    return (
      () => {
        // stop playing sound on component unmount
        sounds.winnerSoundStop();
      },
      []
    );
  });

  useEffect(() => {
    if (!timeoutId) {
      returnToFirstScreenByTimeout();
    }
    return () => {
      // clear timeout on component unmount
      clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  return (
    <div className={cn(styles.wrapper)}>
      {winnerTexts.map((winnerNumber, index) => (
        <div
          className={cn(
            styles.medalWrapper,
            index === 0 ? styles.medalFirst : styles.medalSecond
          )}
          key={index}
        >
          <div className={styles.medalInner}>
            <div className={styles.medalBlock}>
              <img src={MedalImage} alt="medal" className={styles.medalImage} />
              <div className={styles.medalTextWrapper}>
                <p className={styles.gewinnerText}>{t("winner")}</p>
                <p>{t("player")}</p>
                <p className={styles.numberText}>{winnerNumber}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Winner;
